// extracted by mini-css-extract-plugin
export default {"imageFrame":"styles_imageFrame__GCvau","background":"styles_background__4eRB1","main":"styles_main__GEDeJ"};